import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { addAlert } from 'store/actions/alert/alerts';
import { authPatchRequestWithParam } from 'helpers/apiRequests';

import { setFontSize } from 'store/actions/fontSize/setFontSize';

import UserSessionDataHandler from 'auth/UserSessionsDataHandler';

import DefaultComponent from './DefaultComponent';

const DefaultFontSize = () => {
  const [defaultFontSize, setDefaultFontSize] = React.useState(
    UserSessionDataHandler.getFontSize() || 0.6
  );
  const dispatch = useDispatch();

  const [item, setItem] = React.useState(null);

  const useString = () => useSelector(state => state.language);
  const alertsSubtitles = useString().alerts;

  const handleChange = event => {
    setDefaultFontSize(event.target.value);
    UserSessionDataHandler.saveToUserSettingsObjectInStorage(
      UserSessionDataHandler.defaultFontSize,
      event.target.value
    );
    dispatch(setFontSize(event.target.value));
    updateUserFontSize(event.target.value);
  };

  const updateUserFontSize = fontSizeType => {
    const configData = UserSessionDataHandler.getUserConfig();
    const updatedUserData = {
      ...configData,
      fontSize: fontSizeType,
    };
    authPatchRequestWithParam(
      'setUserConfiguration',
      UserSessionDataHandler.getUserDataObject().uid,
      { configuration: updatedUserData }
    ).then(result => {
      if (result.status !== 200)
        dispatch(
          addAlert({
            title: alertsSubtitles[result.data.code].title_,
            desc: alertsSubtitles[result.data.code].desc_,
            type: 'error',
          })
        );
    });
  };

  const subtitle = useString().userSettings.mainSettings;

  React.useEffect(() => {
    setItem({
      name: 'user-font-size',
      label: 'user-font-size-label',
      subtitle: subtitle.defaultFontSize_,
      menu: [
        {
          key_: subtitle.defaultFontSizeOptions.small.key_,
          value_: subtitle.defaultFontSizeOptions.small.value_,
        },
        {
          key_: subtitle.defaultFontSizeOptions.normal.key_,
          value_: subtitle.defaultFontSizeOptions.normal.value_,
        },
        {
          key_: subtitle.defaultFontSizeOptions.large.key_,
          value_: subtitle.defaultFontSizeOptions.large.value_,
        },
      ],
    });
  }, [defaultFontSize]);

  return (
    <DefaultComponent
      item={item}
      defaultItem={defaultFontSize}
      handleChange={handleChange}
    />
  );
};

export default DefaultFontSize;
